import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { logtoClient } from "../../service/Logto";
import Loader from "../../components/Loader";

const Callback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const currentPageUrl = window.location.href;
      const isRedirected = await logtoClient.isSignInRedirected(currentPageUrl);
      if (isRedirected) {
        await logtoClient.handleSignInCallback(currentPageUrl);
        navigate("/contracts");
      }
    })();
  }, [dispatch, navigate]);

  return <Loader isLoading />;
};

export default Callback;
